import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProcessorCard = ({ processor, onConfigure, onTest, onToggle }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-smooth">
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="p-3 bg-primary/10 rounded-lg">
            <Icon name={processor?.icon} size={24} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">{processor?.name}</h3>
            <p className="text-sm text-muted-foreground">{processor?.description}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {processor?.configured && (
            <button
              onClick={() => onToggle(processor?.id)}
              className={`
                relative inline-flex h-6 w-11 items-center rounded-full transition-smooth
                ${processor?.status === 'active' ? 'bg-primary' : 'bg-muted'}
              `}
            >
              <span
                className={`
                  inline-block h-4 w-4 transform rounded-full bg-white transition-smooth
                  ${processor?.status === 'active' ? 'translate-x-6' : 'translate-x-1'}
                `}
              />
            </button>
          )}
        </div>
      </div>

      {/* Status Badge */}
      <div className="flex items-center gap-2 mb-4">
        {processor?.configured ? (
          <>
            <span className={`
              px-2 py-1 text-xs font-medium rounded-full
              ${processor?.status === 'active' ?'bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-300' :'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300'
              }
            `}>
              {processor?.status === 'active' ? 'Active' : 'Inactive'}
            </span>
            {processor?.testMode && (
              <span className="px-2 py-1 text-xs font-medium rounded-full bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300">
                Test Mode
              </span>
            )}
          </>
        ) : (
          <span className="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300">
            Not Configured
          </span>
        )}
      </div>

      {/* Features */}
      <div className="mb-4">
        <p className="text-xs font-medium text-muted-foreground mb-2">Supported Methods</p>
        <div className="flex flex-wrap gap-2">
          {processor?.features?.slice(0, 4)?.map((feature, idx) => (
            <span
              key={idx}
              className="px-2 py-1 text-xs bg-muted text-foreground rounded-md"
            >
              {feature}
            </span>
          ))}
          {processor?.features?.length > 4 && (
            <span className="px-2 py-1 text-xs bg-muted text-muted-foreground rounded-md">
              +{processor?.features?.length - 4} more
            </span>
          )}
        </div>
      </div>

      {/* Details */}
      <div className="space-y-2 mb-4 pb-4 border-b border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Transaction Fee</span>
          <span className="text-foreground font-medium">{processor?.fees}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Currencies</span>
          <span className="text-foreground font-medium">
            {processor?.supportedCurrencies?.length} supported
          </span>
        </div>
        {processor?.configured && processor?.apiKey && (
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">API Key</span>
            <span className="text-foreground font-mono text-xs">{processor?.apiKey}</span>
          </div>
        )}
      </div>

      {/* Actions */}
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="Settings"
          onClick={() => onConfigure(processor)}
          className="flex-1"
        >
          {processor?.configured ? 'Reconfigure' : 'Configure'}
        </Button>
        {processor?.configured && processor?.status === 'active' && (
          <Button
            variant="outline"
            size="sm"
            iconName="Play"
            onClick={() => onTest(processor)}
          >
            Test
          </Button>
        )}
      </div>
    </div>
  );
};

export default ProcessorCard;